import { BCMSRecord, useBCMSContext, useRoute } from "@bcm-dev/bcms-vite";
import { CenterContentContainer, ContentHeaderView, PageContainer, PageContentView } from 'components/shared';
import Classes, { PositivePayCheckTemplate } from "model";
import React from 'react';
import TASPositivePayImportChecksFileImportForm from "./components/TASPositivePayImportChecksFileImportForm";
import TASPositivePayImportChecksTemplateListWidget from "./components/TASPositivePayImportChecksTemplateListWidget";
import "./styles.css";
import "./mobile.css";


/**
 * @function TASPositivePayImportChecksPage
 * @return {React.Component}
 * @exported true
 * @description The TAS Positive Pay Import Checks page.
 */
export default function TASPositivePayImportChecksPage(props) {
  const context = useBCMSContext();
  const navigate = useRoute();
  BCMSRecord.globalControllerFor(Classes, context);

  const data = { ...getDefaultData(undefined, context), ...props.data ?? {} };
  const ui = { ...getDefaultUI(), ...props.ui ?? {} };

  const controller = (state, setState) => ({
    data: state.data,
    ui: state.ui,

    onCreateNewTemplate: () => {
      navigate("/tasPositivePayCreateTemplate")
    }
   });

  return (
    <PageContainer className="tas-positive-pay-import-checks-page" state={ { data, ui } } controller={ controller }>
      <PageContent />
    </PageContainer>
  );
}

export const getDefaultData = () => ({
    templates: PositivePayCheckTemplate.initAll()
    .filter(item => item.id !== undefined)
    .sort((a, b) => {
      return b.id - a.id;
    })
});

export const getDefaultUI = () => ({
  chooseTemplateSelect: { isActive: false }
});

function PageContent(props) {
  return (
    <PageContentView>
         <CenterContentContainer>
            <ContentHeaderView text="Import Checks" />
            <TASPositivePayImportChecksFileImportForm/>
            <TASPositivePayImportChecksTemplateListWidget/>
        </CenterContentContainer>
    </PageContentView>
  );
}